/**
 * fieldChrome — classes canônicas para inputs/labels/campos de formulário.
 * Refinado em SPEC-20260503-1200: focus ring claro, padding consistente, height 36px.
 */

export const FIELD_CLS = "flex flex-col gap-1.5";

export const FIELD_LABEL_CLS = "text-xs font-medium text-foreground";

export const REQ_CLS = "text-danger ml-0.5";

export const INPUT_CLS =
  "h-9 w-full rounded-md border border-border-strong bg-surface px-3 text-sm text-foreground " +
  "placeholder:text-muted-foreground/60 transition-shadow " +
  "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 focus:ring-offset-background focus:border-primary " +
  "disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-surface-2";

export const TEXTAREA_CLS = INPUT_CLS + " min-h-24 py-2 leading-relaxed";

// SELECT_CLS removido em SPEC-20260503-1637 — `<select>` HTML nativo é
// proibido por convenção do ecossistema Wynk; usar `components/ui/select`.

export const HELP_CLS = "text-xs text-muted-foreground leading-snug";

export const ERROR_CLS = "text-xs text-danger leading-snug";
